module.exports = __webpack_public_path__ + "static/media/Arduino.e46838f6.png";